import {useContext} from 'react';

import {UserContext} from 'context';
import {useObservable} from 'hooks';
import {accountPlanStore, onlineSessionsStore, socketStore} from 'services';
import {sessionUtils} from 'utils';

type Response = {
    canJoin: boolean;
    hasActiveSession: boolean;
    activeSessionId: string;
    validScreenRecorder: boolean;
    sessionMinutesLimitExceeded: boolean;
}

export function useSessionReadyState(): Response {
    const context = useContext(UserContext);
    const {joiningSessionId, screenRecorderState} = useObservable(onlineSessionsStore);
    const {authenticated} = useObservable(socketStore);
    const {usage: {inSessionMinutes}, limits} = useObservable(accountPlanStore);
    const activeSession = sessionUtils.getActiveUserSession();
    const requireScreenRecorder = context?.settings?.userSession?.requireScreenRecorder;
    const validScreenRecorder = (!requireScreenRecorder || screenRecorderState?.isOnline && screenRecorderState?.isValidVersion);

    const sessionMinutesLimitExceeded = !!limits && limits.maxInSessionMinutesPerDay < inSessionMinutes;

    return {
        canJoin: !joiningSessionId && validScreenRecorder && !activeSession && authenticated && !sessionMinutesLimitExceeded,
        hasActiveSession: !!activeSession,
        activeSessionId: activeSession?.id,
        validScreenRecorder,
        sessionMinutesLimitExceeded
    };
}